/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { Typography } from '@mui/material';

import {
  CollapsibleTableData,
  CollapsibleTableRow,
} from '@Components/CollapsibleTable';
import { trimMessage } from '@Containers/Report/EmailLog/EmailLog.utils';
import { EmailLogTable } from '@Models/report.model';

/** Returns data for table row in desired format. */
export const createData = (
  id: string,
  sentAt: string,
  emailTo: string,
  message: string,
  actions?: React.ReactNode
): CollapsibleTableData => ({
  primaryData: {
    dateStart: sentAt,
    emailTo,
    message: (
      <div
        // display text as formatted html
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: message }}
        style={{ width: '380px' }}
      />
    ),
    actions,
    idOpenControl: id,
  },
});

/** Returns Map of Grouped Data according to passed key.
 * @param table - table data
 * @param key - key according to which group is to be created
 */
export const getGroupedRows = (
  table: EmailLogTable[],
  key: keyof EmailLogTable
): Map<string, EmailLogTable[]> => {
  const groupedMap = table.reduce(
    (entryMap: Map<string, EmailLogTable[]>, e) =>
      entryMap.set(e[key] as unknown as string, [
        ...(entryMap.get(e[key] as unknown as string) || []),
        e,
      ]),
    new Map()
  );

  return groupedMap;
};

/** Returns Rows for Collapsible Table (Call Log)  */
export const GetRows = (
  table: EmailLogTable[] = [],
  actions: (id: string) => JSX.Element,
  open: { [key: string]: boolean }
): {
  rows: CollapsibleTableRow[];
  groupedMap: Map<string, EmailLogTable[]>;
} => {
  const rows: CollapsibleTableRow[] = [];

  const groupedMap = getGroupedRows(table, 'accountId');

  groupedMap.forEach((group, key) => {
    rows.push({
      id: key,
      name: (
        <Typography variant="main" fontWeight="bold">
          {`${group[0]?.accountName} (${key})`}
        </Typography>
      ),
      data: group.map((row) => {
        const { trimmedMessage, wasTrimmed } = trimMessage(row.message);
        return createData(
          row.id,
          row.sentAt,
          row.emailTo,
          open[row.id] ? row.message : trimmedMessage,
          wasTrimmed ? actions(`${row.id}`) : undefined
        );
      }),
    });
  });

  return { rows, groupedMap };
};
